var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"account-section-container"},[(_vm.title)?_c('h1',{staticClass:"account-section-header"},[_vm._v(_vm._s(_vm.title))]):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }